import React from "react";
import { Link } from "react-router-dom";
import useDocHead from "./docs/useDocHead";

// The client-side half of the 404.
//
// nginx already answers unknown URLs with the prerendered build/404.html
// (see NOT_FOUND_PAGE in scripts/docs-lib.mjs), which is branded and has a way
// back. But that HTML lives in #root, and React replaces #root wholesale the
// moment the bundle boots. With no route matching, React Router rendered
// nothing and the visitor was left staring at an empty black page — the
// branded 404 was on screen for a few hundred milliseconds and then erased.
// That is what /kits looked like while its nginx block was missing.
//
// The copy below is deliberately identical to the prerendered version so the
// handover is invisible: same heading, same line, same two links.
//
// Deliberately NOT a redirect to "/". nginx serves this page with a real 404
// status (error_page 404 /404.html), and bouncing the visitor to the homepage
// would recreate the soft-404 that Search Console flagged and that
// docker/nginx.conf was rewritten to eliminate. A wrong URL should say so and
// offer the way home, not pretend the homepage was what you asked for.
export default function NotFound() {
  // path is only used to build canonical/og:url. Pointing it at /404 rather
  // than the URL that missed keeps every dead link collapsing onto one
  // canonical, instead of minting a canonical for each typo.
  useDocHead({
    title: "Page not found | TrapMan by Voleor",
    description: "That page does not exist. Head back to TrapMan or browse the docs.",
    path: "/404",
    noindex: true,
  });

  return (
    <div className="tm-docs">
      <main className="docs-main">
        <header className="docs-hero">
          <h1 className="h2">Page not found</h1>
          <p className="sub">That link does not lead anywhere</p>
        </header>
        <section className="docs-section doc-prose">
          <p>The page you asked for does not exist, or it has been removed.</p>
          <p>
            <Link to="/">Back to TrapMan</Link> &middot;{" "}
            <Link to="/docs/">Browse the docs</Link>
          </p>
        </section>
      </main>
    </div>
  );
}
